module.exports = __webpack_public_path__ + "img/D1DF0471.8b38f6b3.png";